// import DataTableRow from './DataTableRow';
import PropTypes from 'prop-types';
import React from 'react';
// import classNames from 'classnames';

class SortedData extends React.Component {

  getSortedData() {
    if (!(
      this.props.sortKey
      && this.props.data
      && this.props.data.length
      && this.props.colDefs
      && this.props.colDefs.length)) {
        return this.props.data;
    }

    const sortKey = this.props.sortKey;
    const sortOrder = this.props.sortOrder ? this.props.sortOrder : 'asc';

    // let sortKeyDef = _.find(this.props.colDefs, (colDef) => colDef.key === sortKey ? true: false);
    // let sortKeyDef = this.props.colDefs.find((colDef) => colDef.key === sortKey ? true: false);
    let sortKeyDef = this.props.colDefs.filter((colDef) => colDef.key === sortKey ? true: false)[0];

    if (!sortKeyDef) {
      console.error("Tried to sort on unknown key", sortKey, this.props.colDefs);
      return this.props.data;
    }

    const sortedData = this.props.data.slice(); // Shallow copy array items

    let sortFunction = null;

    if (typeof sortKeyDef.sortFunction === 'function') {
      sortFunction = sortKeyDef.sortFunction;
    } else {
      sortFunction = (rowDataA, rowDataB) => {
        const valueA = rowDataA[sortKey] ? rowDataA[sortKey] : '';
        const valueB = rowDataB[sortKey] ? rowDataB[sortKey] : '';
        if (typeof valueA === 'number' || sortKey === 'id') {
          return valueA.toString().localeCompare(valueB, undefined, {numeric: true});
        } else {
          return valueA.toString().localeCompare(valueB);
        }
      }
    }

    sortedData.sort(sortFunction);

    if (sortOrder === 'desc') {
      sortedData.reverse();
    }

    return sortedData;
  }

  render() {
    const sortedData = this.getSortedData();
    return this.props.children({sortedData});
  }

  static propTypes = {
    children: PropTypes.func,
    sortKey: PropTypes.string,
    sortOrder: PropTypes.string,
    data: PropTypes.array,
    colDefs: PropTypes.array.isRequired,
  };
}

export default SortedData;